/*
  Pellington size guides: one handler for all six guide snippets (2026-10-06).
  Ring (pell-sg), bracelet + adjustable bracelet (pell-blg), necklace (pell-nlg),
  earring (pell-erg), anklet (pell-ank).

  Why: each guide used to carry its own inline <script>. The Quick add window loads a
  product page and drops inline scripts, so "Size guide" did nothing there (Clarity,
  5 Oct: a shopper tapped it twice from the bag, then left). The handler also looked the
  guide up by id, so a second copy on the page could open the wrong one.

  Now: loaded once on every page from the custom-liquid section "pell_size_guide" in
  sections/header-group.json (top of the page). That section also sets the old guard flags
  (window.__pellSG etc.) first, so the inline scripts still in the six guide snippets
  return straight away and never attach their own handlers (blocks/_cart-upsell.liquid
  sets the same flags, because the bag is drawn before the header). Removing that section
  puts the product pages back as they were.

  A tap on "Size guide" opens the guide that sits NEAREST the button (same product),
  copied into a <dialog> opened with showModal(), so it shows above the bag drawer and
  the Quick add window (both are modal dialogs in the browser's top layer).
  Close: x, tap outside, Escape.

  Also logs Clarity events for the bag suggestion: bag_pair_size_add, bag_pair_add,
  size_guide_open (tag size_guide = page | quickadd | bag).
*/
(function () {
  if (window.__pellGuides) return;
  window.__pellGuides = true;

  var KINDS = ['sg', 'blg', 'nlg', 'erg', 'ank'];
  var host = null;
  var lastTrigger = null;
  var prevOverflow = '';

  function clarityEvent(name, tagKey, tagVal) {
    try {
      if (typeof window.clarity === 'function') {
        if (tagKey) window.clarity('set', tagKey, tagVal);
        window.clarity('event', name);
      }
    } catch (e) {}
  }

  function nearestGuide(btn, kind) {
    var n = btn;
    while (n && n !== document) {
      if (n.querySelector) {
        var g = n.querySelector('.pell-' + kind);
        if (g) return g;
      }
      n = n.parentNode;
    }
    return null;
  }

  function getHost() {
    if (host && document.body.contains(host)) return host;
    if (!document.getElementById('pell-guide-host-css')) {
      var st = document.createElement('style');
      st.id = 'pell-guide-host-css';
      st.textContent =
        'dialog.pell-guide-host{position:fixed;inset:0;margin:0;padding:0;border:0;background:transparent;' +
        'width:100%;height:100%;max-width:100%;max-height:100%;overflow:hidden;color:inherit}' +
        'dialog.pell-guide-host::backdrop{background:transparent}' +
        'dialog.pell-guide-host>[class^="pell-"]{display:block}';
      document.head.appendChild(st);
    }
    host = document.createElement('dialog');
    host.className = 'pell-guide-host';
    host.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeGuide();
    });
    document.body.appendChild(host);
    return host;
  }

  function openGuide(btn, kind) {
    var guide = nearestGuide(btn, kind);
    if (!guide) return;
    var h = getHost();
    var copy = guide.cloneNode(true);
    copy.removeAttribute('id');
    copy.hidden = false;
    h.innerHTML = '';
    h.appendChild(copy);
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    if (typeof h.showModal === 'function') {
      if (!h.open) h.showModal();
    } else {
      h.setAttribute('open', '');
    }
    var panel = copy.querySelector('[class$="__panel"]');
    if (panel) panel.scrollTop = 0;
    lastTrigger = btn;
    var where = btn.closest('.pell-cpair') ? 'bag' : btn.closest('quick-add-modal') ? 'quickadd' : 'page';
    clarityEvent('size_guide_open', 'size_guide', where);
  }

  function closeGuide() {
    if (!host) return;
    if (typeof host.close === 'function' && host.open) host.close();
    host.removeAttribute('open');
    host.innerHTML = '';
    document.documentElement.style.overflow = prevOverflow;
    if (lastTrigger && document.body.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
    }
    lastTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    for (var i = 0; i < KINDS.length; i++) {
      var k = KINDS[i];
      var opener = t.closest('[data-pell-' + k + '-open]');
      if (opener) {
        e.preventDefault();
        openGuide(opener, k);
        return;
      }
      if (t.closest('[data-pell-' + k + '-close]')) {
        if (host && host.contains(t)) {
          e.preventDefault();
          closeGuide();
        } else {
          var g = t.closest('.pell-' + k);
          if (g) g.hidden = true;
        }
        return;
      }
    }

    if (t.closest('.pell-cpair__size')) {
      clarityEvent('bag_pair_size_add');
    } else if (t.closest('.pell-cpair .quick-add__submit')) {
      clarityEvent('bag_pair_add');
    }
  });
})();
